export enum reportTabIndexEnum {
    INCOMESTATEMENTSUMMARY = 0,
    BALANCESHEETSUMMARY = 1,
    INCOMESTATEMENTDETAIL = 2,
    BALANCESHEETDETAIL = 3

}